import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";

// data
import { AllLoanList } from "./allLoanList-api";
//auth
import auth from "../../../auth/auth-helper";

const columns = [
  {
    name: "account_no",
    label: "Accunt No",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "amount",
    label: "Amount",
  },
  {
    name: "branch_name",
    label: "Branch Name",
  },
  {
    name: "date",
    label: "Date",
  },
  {
    name: "installment",
    label: "Installement",
  },
  {
    name: "installment_type",
    label: "Installement Type",
  },
  {
    name: "loan_status",
    label: "Status",
  },
  {
    name: "loan_type",
    label: "Loan Type",
  },

  {
    name: "time_period",
    label: "Time Peroid",
  },
];

export default function AllLoans() {
  const [loans, setLoans] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    AllLoanList(signal, credentials).then((res) => {
      if (res.status === 200) {
        console.log("token here ....................." + credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setLoans(res.response[0]);
      } else {
      }
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Loans" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Loan List"
            data={loans}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}
